import axios from 'axios';

const DEFAULT_API_URL = '/api';
const API_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
const ASSET_BASE_URL =
  process.env.REACT_APP_ASSET_URL || API_URL.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token zu Requests hinzufügen
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // Token explizit entfernen, falls vorhanden
    delete config.headers.Authorization;
  }
  return config;
});

// Response-Interceptor: Bei 401 automatisch ausloggen
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token ist ungültig - ausloggen
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Nur redirecten, wenn wir nicht bereits auf der Login-Seite sind und nicht auf öffentlichen Seiten
      const publicPaths = ['/login', '/register', '/dashboard', '/changelog', '/impressum', '/datenschutz'];
      const currentPath = window.location.pathname;
      if (!publicPaths.includes(currentPath) && !currentPath.startsWith('/log/') && !currentPath.startsWith('/profile/')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export { ASSET_BASE_URL };
export default api;

